// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__29NKR","approved":"Status_approved__qiHkq","rejected":"Status_rejected__26AkT","expired":"Status_expired__1byuM","label":"Status_label__3PWlc"};